module.exports = __webpack_public_path__ + "static/media/old-people.55915195.png";